import template from './formActions.template.html';

export default {
  template,
  bindings: {
    onSave: '&'
  },
controller: class controller {
    constructor() {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {};
    }
  }
};
